import styled, { css } from 'styled-components';

export const GoToPage = styled.span(
  ({ theme: { spacers } }) => css`
    margin-right: ${spacers!.spacer01};
  `
);
export const PageSelectorContainer = styled.div(
  ({ theme: { admanColors, spacers } }) => css`
    display: flex;
    align-items: center;
    font-size: 12px;
    line-height: 18px;

    .control {
      border: 1px solid ${admanColors!.gray.dark.bg3[2]};
      min-height: 32px;
      height: 32px;
      min-width: 70px;
      max-height: 32px;
      border-radius: 6px;

      &:focus-within,
      &:hover {
        border: 1px solid ${admanColors!.gray.dark.bg3[2]};
      }
    }

    .control,
    .control:hover,
    .control:focus,
    .control:focus-within {
      padding: 2px ${spacers!.spacer02};
    }

    .valueContainer {
      font-size: 14px;
      line-height: 18px;
      min-width: 40px;
    }

    .dropdownIndicator {
      margin-left: ${spacers!.spacer01};

      svg {
        width: 15px;
        height: 14px;

        path {
          fill: ${admanColors!.gray.light.fg1[0]};
        }
      }
    }

    .menuList {
      max-height: 70px;

      .option {
        padding: ${spacers!.spacer02} ${spacers!.spacer04};

        &::after {
          width: 100%;
          left: 0;
        }
      }
    }
  `
);
